import type { TargetAudience } from 'common/enums/target-audience.enum';
import BaseChangeset from 'common/changesets/base';

export type RecontactFormDTO = {
  type: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  message: string;
  targetAudience?: TargetAudience;
};

export class RecontactFormChangeset extends BaseChangeset<RecontactFormDTO> {}
